import { SpaceFileMimeType } from 'shared';

// Every type the Vault takes, each with the extensions the file picker narrows to (some systems
// report no type for a file). The upload checks read their allowed types from the same keys.
export const VAULT_UPLOAD_ACCEPT: Record<string, string[]> = {
  [SpaceFileMimeType.CSV]: ['.csv'],
  [SpaceFileMimeType.DOC]: ['.doc'],
  [SpaceFileMimeType.DOCX]: ['.docx'],
  [SpaceFileMimeType.JPEG]: ['.jpeg', '.jpg'],
  [SpaceFileMimeType.PDF]: ['.pdf'],
  [SpaceFileMimeType.PNG]: ['.png'],
  [SpaceFileMimeType.XLS]: ['.xls'],
  [SpaceFileMimeType.XLSX]: ['.xlsx'],
};

export const VAULT_UPLOAD_MIME_TYPES = Object.keys(VAULT_UPLOAD_ACCEPT);

export const VAULT_MAX_FILE_SIZE = 10 * 1024 * 1024;

// A drop of any size goes in batches: each is presigned and recorded on its own, so its URLs are
// fresh and a failure costs that batch alone. Within a batch, this many go to storage at a time.
export const VAULT_UPLOAD_BATCH_SIZE = 20;
export const VAULT_PARALLEL_UPLOADS = 6;
